import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type FeatureFlagState = Record<string, boolean | string | number>;

@Injectable({ providedIn: 'root' })
export class FeatureFlagStore {
  private readonly _flags$ = new BehaviorSubject<FeatureFlagState>({});

  readonly flags$: Observable<FeatureFlagState> = this._flags$.asObservable();

  setFlags(flags: FeatureFlagState): void {
    this._flags$.next(flags);
  }

  get currentFlags(): FeatureFlagState {
    return this._flags$.value;
  }
}
